export { default } from './WorkshopSchedule';
